const INITIAL_LOADER_ID = "initial-loader";

export const showInitialLoader = () => document.getElementById(INITIAL_LOADER_ID)?.classList.remove("il-hidden");

export const hideInitialLoader = () => document.getElementById(INITIAL_LOADER_ID)?.classList.add("il-hidden");
